import { Pause as PauseIcon, PlayArrow as PlayArrowIcon } from 'components/icons';
import { cn } from 'utils/cn';

// Play and pause share one cell, the state's own showing. In the new design the pair cross-fades as the state
// changes (icon swap), from `@starting-style`: the button is mounted anew on each change, so the swap has no earlier
// style of its own to move from. Under reduced motion only the opacity changes, in 150ms.
const LAYER =
    '[grid-area:1/1] new:transition-[opacity,filter,scale] new:duration-(--duration-fast) new:ease-in-out new:motion-reduce:duration-150';
const HIDDEN = 'opacity-0 new:motion-safe:scale-[0.25] new:motion-safe:blur-(--blur-small)';
const FROM_HIDDEN =
    'new:starting:opacity-0 new:motion-safe:starting:scale-[0.25] new:motion-safe:starting:blur-(--blur-small)';
const FROM_SHOWN = 'new:starting:opacity-100 new:motion-safe:starting:scale-100 new:motion-safe:starting:blur-[0px]';

const layer = (shown: boolean, swapped: boolean) =>
    cn(LAYER, !shown && HIDDEN, swapped && (shown ? FROM_HIDDEN : FROM_SHOWN));

type Props = {
    tracking: boolean;
    /** Whether the button has been pressed: until then its glyph is simply there, restored state included. */
    swapped?: boolean;
};

/** The glyph of a timecard's start or pause button: pause while it is tracked, play otherwise. */
export default function TrackingGlyph({ tracking, swapped = false }: Props) {
    return (
        <span className="grid place-items-center">
            <PauseIcon className={layer(tracking, swapped)} />
            <PlayArrowIcon className={layer(!tracking, swapped)} />
        </span>
    );
}
